const EventTypeEnum = {
  /** 행사가 */
  EVENT_PRICE: '0',
  /** 전표 할인 */
  //SALE_DISCOUNT: '1',
  /** 품목 할인 */
  ITEM_DISCOUNT: '2',
};

export default EventTypeEnum;
